import { Stats as StatsComponent } from "../../Components";

const Stats = () => {
  return (
    <div className="fullPage">
      <StatsComponent />
    </div>
  );
};

export default Stats;
